import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const SitesView = lazy(async () => {
  const m = await import("@/features/sites/components/sites-view");
  return { default: m.SitesView };
});

export interface SitesSearch {
  /** Deep-link: open the "new site" dialog. */
  new?: string;
  /** Deep-link: open the edit dialog for a specific site. */
  site?: string;
}

export const sitesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/sites",
  validateSearch: (search: Record<string, unknown>): SitesSearch => ({
    new: search.new === "site" ? "site" : undefined,
    site: typeof search.site === "string" ? search.site : undefined,
  }),
  component: () => (
    <Suspense fallback={null}>
      <SitesView />
    </Suspense>
  ),
});
